{
    "Components": {
        "Alert": {
            "ariaLabel": "Cerrar",
            "endChatError": "Error al finalizar la sesión, inténtalo de nuevo",
            "sessionEnded": "La sesión finalizó. Se te redirigió a la página de inicio.",
            "messageError": "Se produjo un problema al conectar con tu sesión, inténtalo de nuevo"
        },
        "Body": {
            "latestMessage": "Mensajes más recientes",
            "loadMessages": "Cargar mensajes",
            "newMessage": "Nuevo mensaje",
            "title": "¿Cómo podemos ayudarte?",
            "subtitle": "¡Hola! Soy el asistente de Servicio de atención al cliente de Ring. ¿Cómo puedo ayudarte hoy?"
        },
        "Bubble": {
            "sourceTitle": "Enlaces útiles"
        },
        "Event": {
            "defaultJoin": "Un miembro del equipo de Ring se unió al chat en directo.",
            "customerJoin": "Transferido al chat en directo.",
            "agentJoin": "se unió al chat en directo.",
            "defaultLeft": "El miembro del equipo de Ring abandonó el chat en directo.",
            "customerLeft": "Abandonaste el chat.",
            "agentLeft": "abandonó el chat en directo.",
            "idle": "Has estado inactivo durante un tiempo. Avísanos si podemos ayudarte.",
            "idleContinue": "Sigo aquí, solo necesito más tiempo",
            "idleEnd": "Finalizar chat",
            "returned": "¡Bienvenido de nuevo! Continuemos con la conversación."
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "Me gusta",
            "ariaLabelThumbsDown": "No me gusta",
            "header": "¿Te resultó útil?",
            "sent": "Gracias por tus comentarios",
            "thumbsDown": "Lamento que mi respuesta no haya sido satisfactoria. Me encantaría recibir tus comentarios sobre cómo mejorar.",
            "thumbsDownResponse": "Gracias por tus comentarios. Intenta reformular tu pregunta.",
            "thumbsUp": "¡Me alegro de que te haya ayudado! Avísame si hay algo más en lo que pueda ayudarte.",
            "RESPONSE_UNCLEAR": "Respuesta poco clara",
            "ISSUE_UNRESOLVED": "No resolvió mi problema",
            "NOT_HELPFUL": "No es útil"
        },
        "Footer": {
            "ariaLabel": "Enviar",
            "placeholder": "Haz una pregunta breve…",
            "subtext": "Este chatbot utiliza IA generativa para responder tus preguntas. Verifica toda la información importante proporcionada en estas respuestas antes de proceder."
        },
        "Header": {
            "ariaLabelMenu": "Menú más",
            "ariaLabelMinimize": "Minimizar",
            "badgeTitle": "BETA",
            "badgeDisabled": "Desconectado",
            "themeLabel": "Tema",
            "muteLabel": "Silenciar",
            "unmuteLabel": "Desilenciar",
            "feedbackLabel": "Give Feedback",
            "endLabel": "Finalizar chat"
        },
        "NotificationCard": {
            "ariaLabelClose": "Cerrar",
            "ariaLabelOpen": "Abrir",
            "notification": "Nuevo mensaje",
            "expand": "Haz clic para expandir"
        },
        "WidgetIcon": {
            "ariaLabel": "Chat para soporte"
        },
        "WelcomeScreen": {
            "ariaLabel": "Minimizar",
            "button": "Iniciar chat",
            "title": "Gracias por comunicarte con Ring",
            "subtitleHtml": "Al continuar, aceptas los <a href='https://ring.com/terms'>Términos de servicio de Ring</a>. Es posible que se recopile y registre la información relacionada con este chat. Consulta nuestro <a href='https://ring.com/privacy-notice'>Aviso de privacidad</a> para obtener más información.",
            "loading": "Iniciando chat...",
            "error": "No se puede iniciar la sesión, inténtalo de nuevo"
        }
    }
}
